import { getEnabledElement } from './enabledElements.js';
import EVENTS from './events.js';
import triggerEvent from './triggerEvent.js';

/**
 * Sets the invalid flag on the enabled element and fires an event
 *
 * @param {HTMLElement} element The DOM element enabled for Cornerstone
 * @returns {void}
 * @memberof Drawing
 */
function invalidate(element) {
  const enabledElement = getEnabledElement(element);

  enabledElement.invalid = true;
  enabledElement.needsRedraw = true;
  const eventData = {
    element,
  };

  triggerEvent(element, EVENTS.INVALIDATED, eventData);
}

export default invalidate;
